
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import SEOHead from '../../components/feature/SEOHead';
import HeroSection from './components/HeroSection';
import MissionTimeline from './components/MissionTimeline';
import TechnologyShowcase from './components/TechnologyShowcase';
import ApplicationsSection from './components/ApplicationsSection';
import CompetitiveEdgeSection from './components/CompetitiveEdgeSection';
import CTASection from './components/CTASection';

export default function Home() {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Vyoamyug Aerospace",
    "url": import.meta.env.VITE_SITE_URL || "https://vyoamyug.com",
    "logo": "https://static.readdy.ai/image/8e9a1ee4738e2b22ec8494c6d9c2fbed/a045d5dcb790742516952289b55d3437.png",
    "description": "Vyoamyug Aerospace is a pioneering aerospace company pushing the boundaries of space exploration with cutting-edge technology, innovative missions, and revolutionary satellite systems.",
    "industry": "Aerospace & Defense",
    "foundingDate": "2020",
    "founder": {
      "@type": "Person",
      "name": "Rahul Dadhich"
    },
    "address": {
      "@type": "PostalAddress",
      "addressCountry": "IN"
    },
    "sameAs": [
      "https://www.linkedin.com/company/vyoamyug",
      "https://twitter.com/vyoamyug"
    ]
  };

  return (
    <div className="min-h-screen bg-black">
      <SEOHead
        title="Vyoamyug Aerospace - Leading Aerospace & Space Technology"
        description="Vyoamyug Aerospace is a pioneering aerospace company pushing the boundaries of space exploration with cutting-edge technology, innovative missions, and revolutionary satellite systems."
        keywords="aerospace, space exploration, satellite technology, space missions, rocket technology, space engineering, satellite systems"
        canonicalUrl={`${import.meta.env.VITE_SITE_URL || 'https://vyoamyug.com'}/`}
        ogTitle="Vyoamyug Aerospace - Leading Aerospace & Space Technology"
        ogDescription="Vyoamyug Aerospace is a pioneering aerospace company pushing the boundaries of space exploration with cutting-edge technology, innovative missions, and revolutionary satellite systems."
        ogImage="https://static.readdy.ai/image/8e9a1ee4738e2b22ec8494c6d9c2fbed/a045d5dcb790742516952289b55d3437.png"
        structuredData={structuredData}
      />
      <Header />
      <main>
        <HeroSection />
        <MissionTimeline />
        <TechnologyShowcase />
        <ApplicationsSection />
        <CompetitiveEdgeSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}